// const baseUrl = "http://localhost:80/api";
// const baseUrl = "https://ims-service-production.up.railway.app/api";
const baseUrl = "https://ims-service-o9zm.onrender.com/api";

export const HEALTH_CHECK_API = `${baseUrl}/health`;
export const VERIFY_TOKEN_API = `${baseUrl}/user/verify`;
export const SIGN_IN_API = `${baseUrl}/user/sign-in`;

export const FETCH_ALL_USER_API = `${baseUrl}/user`;
export const FETCH_ALL_BRAND_API = `${baseUrl}/brand`;
export const FETCH_ALL_SIZE_API = `${baseUrl}/size`;
export const FETCH_ALL_COLOR_API = `${baseUrl}/color`;
export const FETCH_ALL_DEPT_API = `${baseUrl}/dept`;
export const FETCH_ALL_CATEGORY_API = `${baseUrl}/category`;
export const FETCH_ALL_SUBCATEGORY_API = `${baseUrl}/subcategory`;
export const FETCH_ALL_COUNTER_API = `${baseUrl}/counter`;
export const FETCH_ALL_COUNTERS_INCLUDING_INACTIVE_API = `${baseUrl}/counter/all`;
export const FETCH_ALL_DIVISION_API = `${baseUrl}/division`;
export const FETCH_ALL_TYPE_API = `${baseUrl}/type`;
export const FETCH_ALL_ARTICLE_API = `${baseUrl}/article`;
export const FETCH_ALL_FILTERED_ARTICLE_API = `${baseUrl}/article/filtered`;
export const FETCH_ARTICLES_WITH_COLORS_API = `${baseUrl}/article/with-colors`;
export const FETCH_ARTICLES_BY_DEPARTMENT_API = `${baseUrl}/article/by-department`;
export const FETCH_ALL_TRANSACTION_API = `${baseUrl}/transaction`;
export const FETCH_ALL_SHIPPING_API = `${baseUrl}/shipping`;
export const FETCH_RETURN_PRINCIPLE_SHIPPING_API = `${baseUrl}/shipping/return-principle`;
export const FETCH_ALL_STOCK_API = `${baseUrl}/stock`;
export const FETCH_RECEIVED_STOCK_QUANTITY_PER_PRODUCT_TYPE_API = `${baseUrl}/stock/received-quantity-per-product-type`;
export const FETCH_ALL_GIFT_API = `${baseUrl}/gift`;
export const FETCH_ALL_DISCOUNT_API = `${baseUrl}/discount`;
export const FETCH_ALL_MASTERDATA_API = `${baseUrl}/masterdata`;
export const FETCH_ALL_NOTIFICATION_API = `${baseUrl}/notification`;
export const FETCH_ALL_PRINCIPLE_API = `${baseUrl}/principle`;
export const FETCH_ALL_STOCKOPNAME_API = `${baseUrl}/stock-opname`;
export const FETCH_TROUBLED_TRANSACTION_API = `${baseUrl}/transaction/troubled`;
export const FETCH_ALL_DOWNLOADLINK_API = `${baseUrl}/download-link`;
export const FETCH_ALL_ALERTWARNING_API = `${baseUrl}/alert-warning`;
export const FETCH_PROBLEMATIC_STOCKS_API = `${baseUrl}/stock/problematic`;
